@if (appStore.activeSection$ | async; as section) {
  <div class="view-outlet">
    @if (!(appStore.isConnectedView$ | async)) {
      @switch (section) {
        @case ('preparation-area') {
          <andor-preparation-area></andor-preparation-area>
        }
        @case ('show-promo') {
          <andor-show-promo></andor-show-promo>
        }
        @case ('room-login') {
          <andor-room-login></andor-room-login>
        }
        @case ('general-settings') {
          <andor-general-settings></andor-general-settings>
        }
        @case ('sign-in') {
          <andor-user-login></andor-user-login>
        }
        @case ('recover-password') {
          <andor-recover-password></andor-recover-password>
        }
        @case ('about') {
          <andor-about></andor-about>
        }
      }
    } @else {
      @if (odin.status() === OdinConnectionStatus.connected) {
        <andor-conference-panel></andor-conference-panel>
      }
    }
  </div>
}
